import { EMPTY_LIST } from '../../../../../constants/common'
import {
  getPhotoCoverIndex,
  getPhotoImageSrc,
} from '../../../RentalPortalPhotoGallery'

import { QA_NAME_LISTING_PROFILE_HEADER_AVATAR } from './RentalPortalListingProfileHeader.constants'

import FlatIcon from '../../../../../icons/flat.svg'

export function getListingProfileHeaderCoverSrc({ failedSrc, listingData }) {
  const photos = listingData?.photos ?? EMPTY_LIST

  const coverIndex = getPhotoCoverIndex(photos)

  const coverSrc = coverIndex < 0 ? null : getPhotoImageSrc(photos[coverIndex])

  return coverSrc === failedSrc ? null : coverSrc
}

export function getListingProfileHeaderAvatarProps({
  alt,
  className,
  src,
  t,
  onError,
}) {
  return {
    Icon: FlatIcon,
    alt,
    className,
    editable: false,
    imageProps: { onError },
    qaName: QA_NAME_LISTING_PROFILE_HEADER_AVATAR,
    src,
    tooltip: src ? null : t('RentalPortal.ListingProfileHeaderNoCoverPhotoKey'),
  }
}

export function getCanEditListingTitle(listingData) {
  return Boolean(
    !listingData?.archived && listingData?.permissions?.can_edit_content
  )
}
